import { z } from "zod";
import { Id, NonEmpty } from "../base";
import { TimestampSchema } from "../epoch";
//#region Schema
export const ConnectedWalletSchema = z.object({
    id: Id,
    address: NonEmpty, //TODO validate wallet address format
    type: NonEmpty.optional(), // TODO define wallet type enum or validation
    title: NonEmpty.optional(),
    signature: NonEmpty.nullable().optional(),
    nonce: NonEmpty.nullable().optional(),
    isPrimary: z.boolean(),
    connectedAt: TimestampSchema,
});
export const ConnectedWalletPublicSchema = ConnectedWalletSchema.omit({
    signature: true,
    title: true,
    nonce: true,
    isPrimary: true,
    connectedAt: true,
    type: true,
});
/**
 * Request user wallet ownership proof
 */
export const WalletChallengeReqSchema = z.object({
    address: NonEmpty,
    domain: NonEmpty.optional(),
});
/**
 * Save the user wallet ownership proof
 */
export const WalletChallengeRecordSchema = z.object({
    nonce: NonEmpty,
    message: NonEmpty,
    issuedAt: TimestampSchema,
});
// Address-keyed map of active challenges; keys are expected to be wallet addresses
// (e.g., 0x-prefixed hex).
export const WalletChallengesByAddressSchema = z.record(z.string().regex(/^0x[a-fA-F0-9]{40}$/i, {
    message: "Wallet challenge keys must be 0x-prefixed wallet addresses",
}), WalletChallengeRecordSchema);
//#endregion Interfaces
